import auth from './auth';

const redirectToLogin = (nextState, replace) => {
  if (!auth.loggedIn()) {
    replace({
      pathname: '/login',
      state: { nextPathname: nextState.location.pathname },
    });
  }
};

export default redirectToLogin;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/utils/redirectToLogin.js
 **/